import { map, switchMap } from 'rxjs/operators';
import { EpicType, RootState } from '../store';
import { ofType } from 'redux-observable';
import MessagingTopics from '../../../common/messaging/messagingTopics';
import Envelope from '../../../common/messaging/envelope';
import { addCalendarEntryRequest, addCalendarEntryResponse } from '../calendar';

export const addCalendarEntryEpic: EpicType = (action$, state$, dependencies) =>
  action$.pipe(
    ofType(addCalendarEntryRequest),
    map(() => {
      const state: RootState = state$.value;
      return {
        username: state.login.username,
        date: state.calendar.displayedDate,
        comment: state.calendar.dayComment,
        score: state.calendar.dayScore,
      };
    }),
    switchMap((request: any) =>
      dependencies.messagingHub
        .getStream(MessagingTopics.AddHappinessRating, request)
        .pipe(
          map((response: Envelope<any>) => {
            return addCalendarEntryResponse();
          })
        )
    )
  );
